export default __webpack_public_path__ + "static/media/1_0088.370e7ee0.webp";